// components/ProtectedRoute.js
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = ({ children, requiredRole = null }) => {
  const { token, role, loading } = useContext(AuthContext);

  if (loading) return <div>Loading...</div>;

  if (!token) {
    return <Navigate to="/sign-in" replace />;
  }

  if (requiredRole === "admin" && role?.name !== "admin") {
    return <Navigate to="/account" replace />;
  }

  return children;
};

export default ProtectedRoute;
